export const getEnvironment = function (diagnosticsEnvironment) {
  const map = {
    'master-prod': 'production',
    'master-nonprod': 'staging'
  };
  return map[diagnosticsEnvironment] || 'dev';
};